import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const TONES = {
	primary: 'bg-primary-500',
	success: 'bg-success-500',
	caution: 'bg-caution-500',
	warning: 'bg-warning-500',
};

const ProgressBar = ({ value, max, tone = 'primary', className }) => {
	const percent = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;

	return (
		<div
			role="progressbar"
			aria-valuenow={value}
			aria-valuemin={0}
			aria-valuemax={max}
			className={twMerge('h-2 w-full overflow-hidden rounded-full bg-bgBase-400', className)}
		>
			<div className={`h-full rounded-full transition-all ${TONES[tone]}`} style={{ width: `${percent}%` }} />
		</div>
	);
};

ProgressBar.propTypes = {
	value: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	tone: PropTypes.oneOf(Object.keys(TONES)),
	className: PropTypes.string,
};

export default ProgressBar;
